import type { PackageLabelAssignmentWithName } from '../../../../shared/model-typings/packagelabelassignment';
import type { PackageLabelScope } from '../../../../shared/packageLabels';

/**
 * Sort an array of package labels by scope (revision > project > org) and name.
 * @param packageLabels Array of package labels to be sorted.
 * @returns An array of package labels sorted by scope.
 */
export function sortPackageLabelsByScopeAndName(
  packageLabels: PackageLabelAssignmentWithName[],
): PackageLabelAssignmentWithName[] {
  const labelScopeRanking: Record<PackageLabelScope, number> = {
    revision: 1,
    project: 2,
    org: 3,
  };

  // Copy the array of package labels before sorting to avoid unexpected mutation.
  return structuredClone(packageLabels).sort((a, b) => {
    if (labelScopeRanking[a.scope] < labelScopeRanking[b.scope]) {
      return -1;
    }
    if (labelScopeRanking[a.scope] > labelScopeRanking[b.scope]) {
      return 1;
    }

    return a.name?.localeCompare(b.name ?? '') ?? 0;
  });
}
